module.exports = __webpack_public_path__ + "img/shots_off_target.5e8a8f2.png";